import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  taskTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/tasks/templates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useActivateTaskTemplateVersion = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['activateTaskTemplateVersion']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...taskTemplateKeys.activateTaskTemplateVersion,
    ...options,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: taskTemplateKeys.getTaskTemplateVersion({
          templateId: variables.templateId,
          versionId: variables.versionId,
        }).queryKey,
      })
    },
  })
}
